<template>
  <div>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="编码"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="产品单位"></el-table-column>
          <el-table-column prop="BATCH" label="批次"></el-table-column>
          <el-table-column prop="ORDER_PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="生产入库数量"></el-table-column>
          <el-table-column prop="PRODUCT_PRICE" label="入库单价"></el-table-column>
          <el-table-column prop="PRODUCT_WORTH" label="入库总价值"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '../../assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      recordID: sessionStorage.getItem('recordID'),
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryData();
  },
  methods: {
    queryData() {
      const params = {
        SERVICE_ID: '15065',
        OTYPE: 3,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        RECORD_ID: Number(this.recordID),
      };
      http.post(params).then((res) => {
        if (res[0]) {
          res[0].LIST.forEach((element) => {
            if (element.DETAIL_ID == 0) {
              element.REAL_COUNT = element.PRODUCT_COUNT;
            }
          });
          this.tableData = res[0].LIST;
          this.totalCount = res[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalCount = res[0].TOTAL_COUNT;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
  },
};
</script>
<style scoped>
.el-autocomplete /deep/ .el-autocomplete-suggestion {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/productionProcessing/proReceiptDetails.vue